const HERO_THEME_PRESETS = {
  pdf: [
    {
      from: '#172554',
      mid: '#1e3a8a',
      to: '#1d4ed8',
      glowA: 'rgba(255, 187, 94, 0.32)',
      glowB: 'rgba(255, 107, 61, 0.2)',
      tagBg: 'rgba(15, 23, 42, 0.26)',
      tagBorder: 'rgba(255, 255, 255, 0.24)'
    },
    {
      from: '#1f2937',
      mid: '#1e40af',
      to: '#0f766e',
      glowA: 'rgba(45, 212, 191, 0.28)',
      glowB: 'rgba(96, 165, 250, 0.24)',
      tagBg: 'rgba(3, 7, 18, 0.24)',
      tagBorder: 'rgba(148, 163, 184, 0.36)'
    }
  ],
  office: [
    {
      from: '#3f1d7a',
      mid: '#7c3aed',
      to: '#db2777',
      glowA: 'rgba(251, 146, 60, 0.26)',
      glowB: 'rgba(236, 72, 153, 0.24)',
      tagBg: 'rgba(76, 29, 149, 0.3)',
      tagBorder: 'rgba(233, 213, 255, 0.28)'
    },
    {
      from: '#0f172a',
      mid: '#0ea5e9',
      to: '#0284c7',
      glowA: 'rgba(45, 212, 191, 0.3)',
      glowB: 'rgba(56, 189, 248, 0.26)',
      tagBg: 'rgba(2, 132, 199, 0.24)',
      tagBorder: 'rgba(186, 230, 253, 0.32)'
    }
  ],
  subtitle: [
    {
      from: '#111827',
      mid: '#1f2937',
      to: '#4b5563',
      glowA: 'rgba(250, 204, 21, 0.28)',
      glowB: 'rgba(244, 114, 182, 0.24)',
      tagBg: 'rgba(17, 24, 39, 0.32)',
      tagBorder: 'rgba(209, 213, 219, 0.25)'
    },
    {
      from: '#0b132b',
      mid: '#1c2541',
      to: '#3a506b',
      glowA: 'rgba(147, 197, 253, 0.28)',
      glowB: 'rgba(196, 181, 253, 0.24)',
      tagBg: 'rgba(15, 23, 42, 0.3)',
      tagBorder: 'rgba(203, 213, 225, 0.28)'
    }
  ],
  ebook: [
    {
      from: '#14532d',
      mid: '#15803d',
      to: '#0f766e',
      glowA: 'rgba(167, 243, 208, 0.28)',
      glowB: 'rgba(250, 204, 21, 0.22)',
      tagBg: 'rgba(6, 78, 59, 0.32)',
      tagBorder: 'rgba(167, 243, 208, 0.28)'
    },
    {
      from: '#1f2937',
      mid: '#334155',
      to: '#0f766e',
      glowA: 'rgba(45, 212, 191, 0.3)',
      glowB: 'rgba(187, 247, 208, 0.22)',
      tagBg: 'rgba(15, 23, 42, 0.3)',
      tagBorder: 'rgba(167, 243, 208, 0.26)'
    }
  ],
  default: [
    {
      from: '#1e1b4b',
      mid: '#312e81',
      to: '#4338ca',
      glowA: 'rgba(96, 165, 250, 0.26)',
      glowB: 'rgba(196, 181, 253, 0.22)',
      tagBg: 'rgba(30, 27, 75, 0.35)',
      tagBorder: 'rgba(199, 210, 254, 0.28)'
    },
    {
      from: '#0f172a',
      mid: '#334155',
      to: '#2563eb',
      glowA: 'rgba(125, 211, 252, 0.28)',
      glowB: 'rgba(251, 191, 36, 0.2)',
      tagBg: 'rgba(15, 23, 42, 0.32)',
      tagBorder: 'rgba(191, 219, 254, 0.28)'
    }
  ]
};

function detectHeroThemeFamily(scenarioSlug) {
  const normalized = String(scenarioSlug ?? '').trim();
  if (normalized.includes('subtitle') || normalized.includes('srt')) return 'subtitle';
  if (normalized.includes('office') || normalized.includes('word') || normalized.includes('ppt')) return 'office';
  if (normalized.includes('ebook')) return 'ebook';
  if (normalized.includes('pdf') || normalized.includes('contract') || normalized.includes('ocr')) return 'pdf';
  return 'default';
}

function stableHash(input) {
  const source = String(input ?? '');
  let hash = 0;
  for (let i = 0; i < source.length; i += 1) {
    hash = (hash * 31 + source.charCodeAt(i)) >>> 0;
  }
  return hash;
}

function resolveBlogHeroTheme(article) {
  const slug = String(article?.meta?.slug ?? '').trim();
  const scenarioSlug = String(article?.meta?.scenarioSlug ?? '').trim();
  const family = detectHeroThemeFamily(scenarioSlug);
  const presets = HERO_THEME_PRESETS[family] ?? HERO_THEME_PRESETS.default;
  const seed = slug || scenarioSlug || family;
  const index = stableHash(seed) % presets.length;
  const selected = presets[index];
  const imageUrl = `/blog/hero/${slug || 'default'}.jpg`;

  return {
    family,
    className: `theme-${family}`,
    imageUrl,
    styleVars: {
      '--hero-bg-image': `url('${imageUrl}')`,
      '--hero-gradient-from': selected.from,
      '--hero-gradient-mid': selected.mid,
      '--hero-gradient-to': selected.to,
      '--hero-glow-a': selected.glowA,
      '--hero-glow-b': selected.glowB,
      '--hero-tag-bg': selected.tagBg,
      '--hero-tag-border': selected.tagBorder
    }
  };
}

export { resolveBlogHeroTheme };
